"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _portal = _interopRequireDefault(require("../portal"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var PopTip = function PopTip(_ref) {
  var _classNames;

  var _ref$children = _ref.children,
      children = _ref$children === void 0 ? null : _ref$children,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? {} : _ref$style,
      _ref$isPopover = _ref.isPopover,
      isPopover = _ref$isPopover === void 0 ? false : _ref$isPopover,
      _ref$trigger = _ref.trigger,
      trigger = _ref$trigger === void 0 ? 'hover' : _ref$trigger,
      _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? 'dark' : _ref$theme,
      _ref$onVisible = _ref.onVisible,
      onVisible = _ref$onVisible === void 0 ? function () {
    return null;
  } : _ref$onVisible,
      _ref$tipStyle = _ref.tipStyle,
      tipStyle = _ref$tipStyle === void 0 ? {} : _ref$tipStyle,
      visible = _ref.visible,
      onVisibleChange = _ref.onVisibleChange,
      _ref$tipClassName = _ref.tipClassName,
      tipClassName = _ref$tipClassName === void 0 ? '' : _ref$tipClassName,
      tip = _ref.tip,
      _ref$destroyOnHide = _ref.destroyOnHide,
      destroyOnHide = _ref$destroyOnHide === void 0 ? false : _ref$destroyOnHide,
      onTriggerClick = _ref.onTriggerClick,
      onTriggerHover = _ref.onTriggerHover;

  var _useState = (0, React.useState)(visible || false),
      _useState2 = _slicedToArray(_useState, 2),
      popVisible = _useState2[0],
      setPopVisible = _useState2[1];

  var _useState3 = (0, React.useState)({}),
      _useState4 = _slicedToArray(_useState3, 2),
      tipPosition = _useState4[0],
      setTipPosition = _useState4[1];

  var _useState5 = (0, React.useState)({}),
      _useState6 = _slicedToArray(_useState5, 2),
      arrowPosition = _useState6[0],
      setArrowPosition = _useState6[1];

  var popTipRef = (0, React.useRef)();
  var tipRef = (0, React.useRef)();
  var triggerRef = (0, React.useRef)();

  var setPopTipRef = function setPopTipRef(el) {
    return popTipRef.current = el;
  };

  var setTipRef = function setTipRef(el) {
    return tipRef.current = el;
  };

  var setTriggerRef = function setTriggerRef(el) {
    return triggerRef.current = el;
  };

  var clsPrefix = 'kui-poptip';
  var isManualShow = typeof visible !== 'undefined';
  var cls = (0, _classnames["default"])(clsPrefix, className, "".concat(clsPrefix, "--").concat(trigger));
  var triggerCls = (0, _classnames["default"])("".concat(clsPrefix, "__trigger"));
  var tipWrapper = (0, _classnames["default"])("".concat(clsPrefix, "__wrap"), tipClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(clsPrefix, "__wrap--visible"), isManualShow ? visible : popVisible), _defineProperty(_classNames, "".concat(clsPrefix, "__wrap-popover"), isPopover), _defineProperty(_classNames, "".concat(clsPrefix, "__wrap--").concat(placement), placement), _classNames));
  var tipCls = (0, _classnames["default"])("".concat(clsPrefix, "__tip--").concat(theme), "".concat(clsPrefix, "__tip"), "".concat(clsPrefix, "__tip--").concat(placement));
  var arrowCls = (0, _classnames["default"])("".concat(clsPrefix, "__arrow"), _defineProperty({}, "".concat(clsPrefix, "__arrow--").concat(placement), !isPopover), "".concat(clsPrefix, "__arrow--").concat(theme));
  (0, React.useEffect)(function () {
    adjustTipPosition();
  }, []);
  (0, React.useEffect)(function () {
    adjustTipPosition();
    document.body.addEventListener('click', handleBlur, false);
    document.body.addEventListener('mouseout', handleMouseOut, false);
    window.addEventListener('resize', adjustTipPosition);
    return function () {
      document.body.removeEventListener('click', handleBlur, false);
      document.body.removeEventListener('mouseout', handleMouseOut, false);
      window.removeEventListener('resize', adjustTipPosition);
    };
  }, [visible, popVisible]);

  function changeTipVisble(isShow) {
    if (typeof visible !== 'undefined') {
      onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(isShow);
      return;
    }

    setPopVisible(isShow);
  }

  function handleBlur(e) {
    var _popTipRef$current, _tipRef$current;

    if (trigger !== 'click') {
      return;
    } // @ts-ignore


    if (((_popTipRef$current = popTipRef.current) === null || _popTipRef$current === void 0 ? void 0 : _popTipRef$current.contains(e.target)) || ((_tipRef$current = tipRef.current) === null || _tipRef$current === void 0 ? void 0 : _tipRef$current.contains(e.target))) {
      return;
    }

    changeTipVisble(false);
  }

  function handleMouseOver(e) {
    onTriggerHover === null || onTriggerHover === void 0 ? void 0 : onTriggerHover(e);
    if (trigger !== 'hover') return;
    changeTipVisble(true);
  }

  function handleMouseOut(e) {
    var _popTipRef$current2, _tipRef$current2;

    if (trigger !== 'hover') return; // @ts-ignore

    if (((_popTipRef$current2 = popTipRef.current) === null || _popTipRef$current2 === void 0 ? void 0 : _popTipRef$current2.contains(e.target)) || ((_tipRef$current2 = tipRef.current) === null || _tipRef$current2 === void 0 ? void 0 : _tipRef$current2.contains(e.target))) {
      return;
    }

    changeTipVisble(false);
  }

  function handleClick(e) {
    onTriggerClick === null || onTriggerClick === void 0 ? void 0 : onTriggerClick(e);
    if (trigger !== 'click') return;

    if (typeof visible !== 'undefined') {
      onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(!visible);
      return;
    }

    setPopVisible(function (popVisible) {
      return !popVisible;
    });
    onVisible === null || onVisible === void 0 ? void 0 : onVisible();
  }

  function getTriggerPosition() {
    var _triggerRef$current; // @ts-ignore


    var positions = ((_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getBoundingClientRect()) || {};
    return positions;
  }

  function adjustTipPosition() {
    var triggerPosition = getTriggerPosition();
    var tipPosition = {};
    var leftRelateToPage = triggerPosition.left + window.scrollX;
    var topRelateToPage = triggerPosition.top + window.scrollY;
    var arrowWidth = 5;
    var arrowPos = {
      position: 'relative'
    };

    switch (placement) {
      case 'left':
        tipPosition.left = leftRelateToPage - arrowWidth;
        tipPosition.top = topRelateToPage + triggerPosition.height / 2;
        break;

      case 'right':
        tipPosition.top = topRelateToPage + triggerPosition.height / 2;
        tipPosition.left = leftRelateToPage + triggerPosition.width + arrowWidth;
        break;

      case 'top':
        tipPosition.top = topRelateToPage - arrowWidth;
        tipPosition.left = leftRelateToPage + triggerPosition.width / 2;
        break;

      case 'bottom':
        tipPosition.top = topRelateToPage + triggerPosition.height + arrowWidth;
        tipPosition.left = leftRelateToPage + triggerPosition.width / 2;
        break;

      case 'bottom-left':
        tipPosition.top = topRelateToPage + triggerPosition.height + arrowWidth;
        tipPosition.left = leftRelateToPage;
        arrowPos.left = triggerPosition.width / 2;
        break;

      case 'bottom-right':
        tipPosition.top = topRelateToPage + triggerPosition.height + arrowWidth;
        tipPosition.left = leftRelateToPage + triggerPosition.width;
        arrowPos.left = triggerPosition.width / 2 * -1;
        break;

      case 'right-top':
        tipPosition.top = topRelateToPage;
        tipPosition.left = leftRelateToPage + triggerPosition.width + arrowWidth;
        arrowPos.top = triggerPosition.height / 2;
        break;

      case 'right-bottom':
        tipPosition.top = topRelateToPage + triggerPosition.height;
        tipPosition.left = leftRelateToPage + triggerPosition.width + arrowWidth;
        break;

      case 'left-bottom':
        tipPosition.left = leftRelateToPage - arrowWidth;
        tipPosition.top = topRelateToPage + triggerPosition.height;
        break;

      case 'left-top':
        tipPosition.left = leftRelateToPage - arrowWidth;
        tipPosition.top = topRelateToPage;
        arrowPos.top = triggerPosition.height / 2;
        break;

      case 'top-left':
        tipPosition.top = topRelateToPage - arrowWidth;
        tipPosition.left = leftRelateToPage;
        arrowPos.left = triggerPosition.width / 2;
        break;

      case 'top-right':
        tipPosition.top = topRelateToPage - arrowWidth;
        tipPosition.left = leftRelateToPage + triggerPosition.width;
        arrowPos.left = triggerPosition.width / 2 * -1;
        break;
    }

    setTipPosition(tipPosition);
    setArrowPosition(arrowPos);
  }

  var container = document.querySelector('#root');
  return /*#__PURE__*/React.createElement("div", {
    className: cls,
    style: style,
    ref: setPopTipRef,
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("div", {
    className: triggerCls,
    onClick: handleClick,
    onMouseOver: handleMouseOver,
    ref: setTriggerRef
  }, children), destroyOnHide ? visible || popVisible ? /*#__PURE__*/React.createElement(_portal["default"], {
    container: container
  }, /*#__PURE__*/React.createElement("div", {
    className: tipWrapper,
    style: _objectSpread({}, tipPosition),
    ref: setTipRef
  }, /*#__PURE__*/React.createElement("div", {
    className: arrowCls
  }), /*#__PURE__*/React.createElement("div", {
    className: tipCls,
    style: _objectSpread({}, tipStyle)
  }, tip))) : null : /*#__PURE__*/React.createElement(_portal["default"], {
    container: container
  }, /*#__PURE__*/React.createElement("div", {
    className: tipWrapper,
    style: _objectSpread({}, tipPosition),
    ref: setTipRef
  }, /*#__PURE__*/React.createElement("div", {
    className: arrowCls,
    style: arrowPosition
  }), /*#__PURE__*/React.createElement("div", {
    className: tipCls,
    style: _objectSpread({}, tipStyle)
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(clsPrefix, "__tip-inner")
  }, tip)))));
};

var _default = PopTip;
exports["default"] = _default;